<template>
    <el-dialog :visible.sync="showMessageCenter" class="messageCenter" width="800px"
               @close="$emit('messageCenterClose')">
        <div class="messageCenter">
            <!-- 顶部标题和统计 -->
            <div class="header">
                <div class="header-left">
                    <h1><i class="fas fa-envelope"></i> 消息中心</h1>
                </div>
            </div>
            <!-- 主体内容区域 -->
            <div class="container">
                <!-- 顶部切换选项卡 -->
                <div class="tab-switcher">
                    <button
                        :class="['tab-btn', { active: activeTab === 'chat' }]"
                        @click="changeTab('chat')"
                    >
                        <i class="fas fa-comments"></i>
                        用户沟通 <span v-if="unreadChatCount > 0" class="badge">{{ unreadChatCount }}</span>
                    </button>
                    <button
                        :class="['tab-btn', { active: activeTab === 'notification' }]"
                        @click="changeTab('notification')"
                    >
                        <i class="fas fa-bell"></i>
                        系统通知 <span v-if="unreadNotificationCount > 0" class="badge">{{
                            unreadNotificationCount
                        }}</span>
                    </button>
                </div>

                <!-- 根据选项卡显示不同内容 -->
                <div class="tab-content">
                    <ChatList
                        v-if="activeTab === 'chat'"
                        ref="chatList"
                        @open-chat="openChatModal"
                    />
                    <NotificationList v-if="activeTab === 'notification'"
                                      ref="notificationList"
                                      @refreshInformation="unreadNotificationCount = 0,$emit('refreshNumber')"
                                      @refreshNumber="unreadNotificationCount-=1,$emit('refreshNumber')"
                    />
                </div>
            </div>

            <!-- 聊天弹框组件 -->
            <ChatModal
                :show="showChatModal"
                :user-info="currentChat"
                @close="closeChatModal"
            />

        </div>
    </el-dialog>
</template>

<script>
import ChatList from './ChatList.vue'
import NotificationList from './NotificationList.vue'
import ChatModal from './ChatModal.vue'
import Api from '@/components/Api/index.js'

export default {
    name: 'messageCenter',
    components: {
        ChatList,
        NotificationList,
        ChatModal
    },
    data() {
        return {
            showMessageCenter: false,
            activeTab: 'chat',
            showChatModal: false,
            showNotificationModal: false,
            unreadNotificationCount: 0,
            unreadChatCount: 0,
            currentChat: null,
        }
    },
    mounted() {
        this.getMessageCount()
        window.addEventListener("onmessageWS", data => {
            this.getMessageCount()
            if (this.activeTab === 'chat') {
                this.$refs.chatList.getMessageList()
            } else {
                this.$refs.notificationList.getMessageList()
            }
        })
    },
    beforeDestroy() {
        //移除监听
        window.removeEventListener('onmessageWS', data => {
        })
    },
    methods: {
        refreshNumber() {
            alert(0)
            setTimeout(() => this.$emit('refreshNumber'), 2000)
        },
        openChatModal(chat) {
            this.unreadChatCount = 0
            this.currentChat = chat
            this.showChatModal = true
        },
        //获取消息数量
        getMessageCount() {
            //用户沟通消息的未读数量
            new Api('oauth').getMessageNumber(2).then(res => {
                if (res.status === 200) {
                    this.unreadChatCount = res.data
                }
            })
            //系统消息的未读
            new Api('oauth').getMessageNumber(1).then(res => {
                if (res.status === 200) {
                    this.unreadNotificationCount = res.data
                }
            })
        },
        //打开消息中心
        openCenterPop() {
            this.showMessageCenter = true
        },
        changeTab(tab) {
            this.activeTab = tab
        },
        closeChatModal() {
            this.$emit('refreshNumber')
            this.showChatModal = false
            this.currentChat = null
        },
    }
}
</script>

<style scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
}

.header-left h1 {
    font-size: 28px;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
}

.header-left h1 i {
    color: #3498db;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.tab-switcher {
    display: flex;
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    overflow: hidden;
}

.tab-btn {
    flex: 1;
    padding: 15px 20px;
    background: none;
    border: none;
    font-size: 16px;
    font-weight: 600;
    color: #7f8c8d;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.3s;
}

.tab-btn:hover {
    background-color: #f8f9fa;
}

.tab-btn.active {
    color: #3498db;
    background-color: #e8f4fc;
    position: relative;
}

.tab-btn.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #3498db;
}

.tab-btn .badge {
    background-color: #e74c3c;
    color: white;
    border-radius: 12px;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 600;
}

.tab-content {
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    min-height: 500px;
}
</style>